import { gql } from '@apollo/client';


export const GET_PROFILE_POINTS_TOTAL = gql`
     query getAcreditacionProfilePointsTotal($profile_uuid:ID!){
          getAcreditacionProfilePointsTotal(profile_uuid:$profile_uuid)
     }   
`;

export const GET_PROFILE_POINTS_TOTAL_AND_LIST_PRODUCTS = gql`
     query getAcreditacionProfilePointsTotal($profile_uuid:ID! $status:String){
          getAcreditacionProfilePointsTotal(profile_uuid:$profile_uuid),
          listProfilePointsProducts{
               edge{
                   id,
                   name,
                   tournament_id,
                   orden,
                   amount
                   text_adicional
               },
               total
           },
           listProfilePointsOrders(profile_uuid:$profile_uuid status:$status){
               edge{
                 id,
                 tournament_id,
         
                 acreditaciones_profile_uuid,
                 acreditaciones_profiles_points_products_id,
                 AcreditacionesProfilesPointsProducts{
                     id,
                     name,
                     amount
                 },
                 status,
                 amount,
                 
                 completed_at,
                 created_at
               },
               total
           }
     },   
`;